var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVikt = function SvgVikt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d96973",
    d: "M69.179 23.516c3.691 15.989-10.985 34.476-26.95 38.162S4.386 62.663.695 46.676C-3 30.67 14.674 4.6 30.64.914c16.365-3.779 34.848 6.615 38.539 22.602z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 35,
    height: 35,
    x: 18,
    y: 15,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.29 15.164H52.9v34.61H18.29v-34.61z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M51.877 46.076a2.678 2.678 0 0 1-2.675 2.675H21.988a2.678 2.678 0 0 1-2.675-2.675V18.862a2.678 2.678 0 0 1 2.675-2.675h27.214a2.678 2.678 0 0 1 2.675 2.675v27.214zm-2.675-30.912H21.988a3.702 3.702 0 0 0-3.698 3.698v27.214a3.703 3.703 0 0 0 3.698 3.698h27.214a3.703 3.703 0 0 0 3.699-3.698V18.862a3.702 3.702 0 0 0-3.699-3.698z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.249 19.779c3.835 0 7.463 1.11 10.525 3.217l-3.934 4.271a12.137 12.137 0 0 0-4.942-1.776l1.153-3.615c.081-.256-.075-.524-.348-.6s-.562.07-.644.325l-1.21 3.797a13.35 13.35 0 0 0-.6-.016c-2.377 0-4.647.65-6.596 1.885l-3.933-4.271c3.062-2.106 6.69-3.216 10.529-3.216v-.001zm-7.074 8.45a.543.543 0 0 0 .7.074c1.855-1.279 4.058-1.955 6.373-1.955s4.514.677 6.37 1.955a.533.533 0 0 0 .307.095c.145 0 .29-.058.392-.168l4.599-4.993a.462.462 0 0 0-.074-.694c-3.333-2.439-7.343-3.729-11.593-3.729s-8.265 1.29-11.598 3.728a.475.475 0 0 0-.197.332.462.462 0 0 0 .123.362l4.599 4.993zm19.836 17.123H23.22c-.278 0-.504.33-.504.737s.226.737.504.737h24.79c.278 0 .504-.33.504-.737s-.226-.737-.504-.737z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgVikt;